<template>
  <div class="main_center" style="padding:16px;background-color: rgb(240, 242, 245);">
    <div class="content">
      <el-form ref="form" :model="form" label-width="110px" style="padding-top: 16px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="统计维度：">
              <el-select v-model="form.dimension" value-key="value" style="width: 100%" @change="typeListChange">
                <el-option v-for="(item, index) of dimensionList" :key="index" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- dimension 1年 2季度 3月 -->
            <el-form-item v-show="form.dimension === '3'" label="时间周期：" props="dateTime1">
              <el-date-picker v-model="form.year" type="month" style="width:100%;" format="yyyy-MM" value-format="yyyy-MM"
                placeholder="选择月"></el-date-picker>
            </el-form-item>
            <el-form-item v-show="form.dimension === '1'" label="时间周期：" props="dateTime2">
              <el-date-picker v-model="form.year" type="year" style="width:100%;" value-format="yyyy" format="yyyy" placeholder="选择年">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item v-show="form.dimension === '2'" label="时间周期：" props="dateTime3">
              <div style="display: flex;">
                <el-date-picker v-model="form.year" type="year" format="yyyy" value-format="yyyy" placeholder="选择年">
                </el-date-picker>
                <el-select v-model="form.period" placeholder="请选择季度">
                  <el-option v-for="item in quarterList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="所属交易中心：" props="tradeId">
              <el-select v-model="form.tradeId" clearable value-key="value" style="width: 100%">
                <el-option v-for="item in tradeOrgIdOptions"
                           :key="item.id"
                           :label="item.orgName"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="招标方式：" props="tradeId">
              <el-select v-model="form.tenderModeListvalue" clearable value-key="value" style="width: 100%">
                <el-option v-for="(item, index) in tenderModeList" :key="index" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="招标项目类型：" props="tradeId">
              <el-select v-model="form.buyprojectTypeListvalue" clearable value-key="value" style="width: 100%">
                <el-option v-for="(item, index) in buyprojectTypeList" :key="index" :label="item.name"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="评定分离：" props="tradeId">
              <el-select v-model="form.isassessmentseparationListvalue" clearable value-key="value" style="width: 100%">
                <el-option v-for="(item, index) in isassessmentseparationList" :key="index" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="">
              <div>
                <el-button size="mini" type="primary" @click="searchBtn">统计</el-button>
                <el-button size="mini" @click="getreportexporttype('0')">导出excel</el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="padding: 0px 16px 16px;background-color: #FFF">
        <div class="big_box">
          <div class="project_box">
            <div class="title center_TT">项目数量统计</div>
            <div class="content_box">
              <div class="content_box_30">
                <div class="content_box_30_title blue1 borderColor center_TT">进场项目（标段）数</div>
                <div class="flex">
                  <div class="content_box_33_center">
                    <div class="content_box_30_title blue2 borderColor center_TT">数量</div>
                    <div class="text_num">
                      <el-button size="mini" type="primary" plain @click="getreportexporttype('1')">导出</el-button>
                      {{ tableData.countBid }}
                    </div>
                  </div>
                  <div class="content_box_33_center">
                    <div class="content_box_30_title blue2 borderColor center_TT">同比增长</div>
                    <div class="text_num">{{ tableData.increaseBid }}</div>
                  </div>
                  <div class="content_box_33_center">
                    <div class="content_box_30_title blue2 borderColor center_TT">增长率</div>
                    <div class="text_num">{{ tableData.growthrateBid }}</div>
                  </div>
                </div>
              </div>
              <div class="content_box_30">
                <div class="content_box_30_title blue1 borderColor center_TT">实际成交数</div>
                <div class="flex">
                  <div class="content_box_33_center">
                    <div class="content_box_30_title blue2 borderColor center_TT">数量</div>
                    <div class="text_num">{{ tableData.countBidOk }}</div>
                  </div>
                  <div class="content_box_33_center">
                    <div class="content_box_30_title blue2 borderColor center_TT">同比增长</div>
                    <div class="text_num">{{ tableData.increaseBidOk }}</div>
                  </div>
                  <div class="content_box_33_center">
                    <div class="content_box_30_title blue2 borderColor center_TT">增长率</div>
                    <div class="text_num">{{ tableData.growthrateBidOk }}</div>
                  </div>
                </div>
              </div>
              <div class="content_box_30">
                <div class="content_box_30_title blue1 borderColor center_TT">废标数</div>
                <div class="flex">
                  <div class="content_box_33_center">
                    <div class="content_box_30_title blue2 borderColor center_TT">数量</div>
                    <div class="text_num">{{ tableData.countAbandone }}</div>
                  </div>
                  <div class="content_box_33_center">
                    <div class="content_box_30_title blue2 borderColor center_TT">同比增长</div>
                    <div class="text_num">{{ tableData.increaseAbandone }}</div>
                  </div>
                  <div class="content_box_33_center">
                    <div class="content_box_30_title blue2 borderColor center_TT">增长率</div>
                    <div class="text_num">{{ tableData.growthrateAbandone }}</div>
                  </div>
                </div>
              </div>
              <div class="content_box_10">
                <div class="content_box_30_title blue1 borderColor center_TT">终止数</div>
                <div class="text_num_100">
                  {{ tableData.countStop }}
                </div>
              </div>
            </div>
            <div class="content_box_t">
              <div class="content_box_30_center">
                <div class="content_box_30_title blue2 borderColor center_TT">待定标数</div>
                <div class="text_num">{{ tableData.pendbiddingCount }}</div>
              </div>
              <div class="content_box_30_center">
                <div class="content_box_30_title blue2 borderColor center_TT">评定分离项目（标段）数</div>
                <div class="text_num">{{ tableData.separationCount }}</div>
              </div>
              <div class="content_box_40_center">
                <div class="content_box_30_title blue2 borderColor center_TT">远程异地评标项目（标段）数</div>
                <div class="text_num">{{ tableData.remoteCount }}</div>
              </div>
            </div>
          </div>

          <div class="project_box">
            <div class="title center_TT">交易金额统计</div>
            <div class="content_box">
              <div class="content_box_45">
                <div class="content_box_30_title blue1 borderColor center_TT">交易总额</div>
                <div class="flex">
                  <div class="content_box_33_center">
                    <div class="content_box_30_title blue2 borderColor center_TT">金额（万元）</div>
                    <div class="text_num">{{ tableData.totaltransactionAmount }}</div>
                  </div>
                  <div class="content_box_33_center">
                    <div class="content_box_30_title blue2 borderColor center_TT">同比增长（万元）</div>
                    <div class="text_num">{{ tableData.totaltransactionIncrease }}</div>
                  </div>
                  <div class="content_box_33_center">
                    <div class="content_box_30_title blue2 borderColor center_TT">增长率</div>
                    <div class="text_num">{{ tableData.totaltransactionGrowthrate }}</div>
                  </div>
                </div>
              </div>
              <div class="content_box_45">
                <div class="content_box_30_title blue1 borderColor center_TT">节约总额</div>
                <div class="flex">
                  <div class="content_box_33_center">
                    <div class="content_box_30_title blue2 borderColor center_TT">金额（万元）</div>
                    <div class="text_num">{{ tableData.totalsavingAmount }}</div>
                  </div>
                  <div class="content_box_33_center">
                    <div class="content_box_30_title blue2 borderColor center_TT">同比增长（万元）</div>
                    <div class="text_num">{{ tableData.totalsavingIncrease }}</div>
                  </div>
                  <div class="content_box_33_center">
                    <div class="content_box_30_title blue2 borderColor center_TT">增长率</div>
                    <div class="text_num">{{ tableData.totalsavingGrowthrate }}</div>
                  </div>
                </div>
              </div>
              <div class="content_box_10">
                <div class="content_box_30_title blue1 borderColor center_TT">资金节约率</div>
                <div class="text_num_100">
                  {{ tableData.savingRate }}
                </div>
              </div>
            </div>
          </div>

          <div class="project_box">
            <div class="title center_TT">交易主体参与情况统计</div>
            <div class="content_box_t">
              <div class="content_box_20_center">
                <div class="content_box_30_title blue2 borderColor center_TT">中小企业中标率</div>
                <div class="text_num">{{ tableData.smentBidderRate }}</div>
              </div>
              <div class="content_box_20_center">
                <div class="content_box_30_title blue2 borderColor center_TT">外地企业中标率</div>
                <div class="text_num">{{ tableData.nolocalentBidderRate }}</div>
              </div>
              <div class="content_box_20_center">
                <div class="content_box_30_title blue2 borderColor center_TT">进场代理业务的代理机构数量</div>
                <div class="text_num">
                  <el-button size="mini" type="primary" plain @click="getreportexporttype('2')">导出</el-button>
                  {{ tableData.agencyCount }}
                </div>
              </div>
              <div class="content_box_20_center">
                <div class="content_box_30_title blue2 borderColor center_TT">投标企业数量</div>
                <div class="text_num">
                  <el-button size="mini" type="primary" plain @click="getreportexporttype('3')">导出</el-button>
                  {{ tableData.applyCount }}
                </div>
              </div>
              <div class="content_box_20_center">
                <div class="content_box_30_title blue2 borderColor center_TT">中标企业数量</div>
                <div class="text_num">
                  <el-button size="mini" type="primary" plain @click="getreportexporttype('4')">导出</el-button>
                  {{ tableData.bidderCount }}
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import moment from "moment";

export default {
  name: "expertExtractList",
  components: {},
  data() {
    return {
      dateTimeList: [
        { name: 1, value: moment().subtract(1, "month").format("YYYY-MM") },
        { name: 2, value: moment().format("YYYY") },
        {
          name: 3,
          value: [
            moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD"),
            moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD"),
          ],
        },
      ],
      form: {
        dimension: '1', //统计维度 1年 2季度 3月
        period: '',//季度
        year: "", //时间类型
        tenderModeListvalue: '',//招标方式
        buyprojectTypeListvalue: '',//招标项目类型
        isassessmentseparationListvalue: '', //评定分离   1全部 2是 3否
        dateTime1: moment().subtract(1, "month").format("YYYY-MM"),
        dateTime2: moment().format("YYYY"),
        dateTime3: [
          moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD"),
          moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD"),
        ],
        tradeId: "", // 交易中心ID
        searchKey: "",
      },
      businessType: "GC",
      moreSearchItem: false,
      startandenddates: [],
      exportlist: [], //进场项目导出

      // 统计维度 1年 2季度 3月
      dimensionList: [
        {value: '1', label: '按年统计'},
        {value: '2', label: '按季度统计'},
        {value: '3', label: '按月统计'},

      ],

      // 招标方式
      tenderModeList: [
        {value: '0', label: '全部'},
        {value: '1', label: '公开招标'},
        {value: '2', label: '邀请招标'},
      ],

      // 招标项目类型
      buyprojectTypeList: [

      ],

      // 评定分离
      isassessmentseparationList: [
        {value: '2', label: '全部'},
        {value: '1', label: '是'},
        {value: '0', label: '否'},
      ],

      quarterList: [
        {value: '1', label: '第一季度'},
        {value: '2', label: '第二季度'},
        {value: '3', label: '第三季度'},
        {value: '4', label: '第四季度'},
      ],
      tableData: {},
      pageIndex: 1,
      pageSize: 10,
      dataListLoading: false,
      inputHtml: "",
      sortParams: {
        prop: "",
        order: "",
      },
      tradeOrgIdOptions:[],
      transactionCenterList: [],
      reportexporttype:'' //报表导出类型
    };
  },
  watch: {},
  created() {
    this.getDic('146') //招标项目类型请求
    this.getList()
    this.gettradeOrgData();
  },
  activated() {
    this.getList();
  },
  mounted() {
    this.ifmove();
    let resizeTag = true;
    let that = this;
    window.onresize = () => {
      if (resizeTag) {
        //防抖动
        that.ifmove();
        resizeTag = false;
        setTimeout(() => {
          resizeTag = true;
        }, 1000);
      }
    };
  },
  methods: {
    gettradeOrgData(){
      this.$httpReq.post('/sysGuardConfig/traddingOrgPage',{
        "page": 1,
        "rows": 100,
        "searchKey": "",
      }).then((data)=>{
        this.tradeOrgIdOptions=data.data.rows;
      })
    },
    // 获取字典
    getDic(type) {
      this.$httpReq.get('/sys/dictData/getList?type=' + type).then(res => {
        if (res.data.code === '1') {
          switch (type) {
            case '146':
              this.buyprojectTypeList = res.data.data;
              break;
          }
        }
      })
    },

    // 搜索区总导出
    exportExcel() {
      
      /**
     *  汇总统计-导出报表
     * @param response
     * @param type 0 所有5张报表 1进场项目统计 2代理机构清单 3投标企业名单 4中标企业名单
     * @param dimension 维度 1年 2季度 3月
     * @param year 年
     * @param period 周期 dimension=1：year；dimension=2：1\2\3\4；dimension=3：year+month；
     * @param tradeId  交易中心
     * @param tenderMode 招标方式
     * @param buyprojectType 项目类型
     * @param isassessmentseparation 是否评定分离
     */

     let baseParams = {
        type:this.reportexporttype, //报表导出类型值
        dimension: this.form.dimension,// 统计维度 1年 2季度 3月
        period:"",
        year: this.form.year,
        tradeId: this.form.tradeId,//交易中心
        tenderMode: this.form.tenderModeListvalue,//招标方式
        buyprojectType: this.form.buyprojectTypeListvalue, //项目类型
        isassessmentseparation: this.form.isassessmentseparationListvalue,//是否评定分离
      };
      switch (this.form.dimension) {
        // 统计维度 1年 2季度 3月
        case '1': baseParams.period = this.form.year;break;
        case '2': baseParams.period = this.form.period;break;
        case '3': baseParams.period = this.form.year;break;
      }
      const query = qs.stringify(baseParams);
      const url = `${dgwitnessBaseRouterUrl}/api/tradeStatistics/exportStatisticsSummary?${query}`;
      window.open(url);
    },



    // 获取汇总数据数据
    getList() {

      // 根据选择的时间类型准备请求参数
      let baseParams = {
        dimension: this.form.dimension,// 统计维度 1年 2季度 3月
        year: this.form.year, //年
        tradeId: this.form.tradeId,//交易中心
        tenderMode: this.form.tenderModeListvalue,//招标方式
        buyprojectType: this.form.buyprojectTypeListvalue, //项目类型
        isassessmentseparation: this.form.isassessmentseparationListvalue,//是否评定分离
        period:'',// period 周期 dimension=1：year；dimension=2：1\2\3\4；dimension=3：year+month；
      };


      switch (this.form.dimension) {
        // 统计维度 1年 2季度 3月
        case '1': baseParams.period = this.form.year;break;
        case '2': baseParams.period = this.form.period;break;
        case '3':
          baseParams.period = this.form.year;
          baseParams.year = this.form.year.slice(0,4);
          break;
      }

      const query = qs.stringify(baseParams);
      this.$httpReq
        .get(`/tradeStatistics/statisticsSummaryForm?${query}`,{baseURL:process.env.VUE_APP_proxybaseurl + dgwitnessBaseUrl})
        .then((res) => {
          if (res.data.code === '1') {
            this.tableData = res.data.data || {};
          }
        });
    },


    // 报表类型设置事件
    getreportexporttype(type){

      this.reportexporttype = type
      this.exportExcel()
    },


    searchBtn() {
      this.pageIndex = 1;
      this.getList()

    },
    refresh() {
      this.form = {
        year: new Date().getFullYear(),
        searchKey: "",
        tradeId: "", // 交易中心ID
      };
      this.pageIndex = 1;
      this.getList();
    },
    dateTimeChange(val) {
      this.form.dateTime = val;
    },
    typeListChange(val) {
      // const obj = this.dateTimeList.find((item) => item.name === val);
      // this.form.dateTime = obj.value || null;
        this.$refs['form'].resetFields();
        const that = this;
        setTimeout(function(){
            that.$refs['form'].resetFields();
            that.form.year = ''
            that.form.period=''
        },100)
    },
    paginationChange({ page, limit }) {
      this.pageIndex = page;
      this.pageSize = limit;
      this.getList();
    },
    indexMethod(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1;
    },
  },

};
</script>
<style lang="scss" scoped>
.center_TT {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex {
  display: flex;
}

.blue1 {
  background-color: rgb(108, 209, 253);
}

.blue2 {
  background-color: rgb(172, 226, 249);
}

.borderColor {
  border: 1px solid #dcdfe6;
}

.title {
  width: 100%;
  height: 50px;
  color: #fff;
  font-size: 22px;
  font-weight: 600;
  background-color: #409eff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: none;
}

.content_box_30_title {
  width: 100%;
  height: 40px;
  font-size: 16px;
  border-bottom: none;
  border-right: none;

}

.text_num {
  height: 60px;
  border: 1px solid #dcdfe6;
  border-right: none;
  border-bottom: none;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.text_num_100 {
  height: 100px;
  border: 1px solid #dcdfe6;
  border-bottom: none;
  border-right: none;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.big_box {
  border: 1px solid #dcdfe6;
}

.content_box {
  width: 100%;
  display: flex;

  .content_box_30 {
    width: 30%;

    .content_box_33_center {
      width: 33.333%;

    }
  }
}

.content_box_10 {
  width: 10%;
}

.content_box_45 {
  width: 45%;

  .content_box_33_center {
    width: 33.333%;

  }
}


.content_box_t {
  width: 100%;
  display: flex;

  .content_box_30_center {
    width: 30%;
  }

  .content_box_40_center {
    width: 40%;
  }
}

.content_box_20_center {
  width: 20%;
}
</style>
